import Decimal from "decimal.js";

export const formatCurrency = (input: number | Decimal, currency?: string) => {
  const number = typeof input === "number" ? input : input.toNumber();

  return new Intl.NumberFormat("pl-PL", { style: "currency", currency }).format(number);
};
